import React from "react";
import { Row, Container } from 'react-bootstrap';

import './About.scss';

export default function About() {
  return (
    <Row>
      <Container className="about-container">
        <h2 className="policy-about-title">The benefit of a complimentary policy review</h2>
        <p>The life insurance policy you bought may have been the right coverage for you and your loved ones at that time - but that doesn't mean your needs will stay the same throughout your life.</p>
        <p><span>Some common events</span> that may trigger changes in your life insurance needs include:</p>
        <ul>
          <li>Debt Changes</li>
          <li>Family Events and Fluctuations</li>
          <li>Financial Changes</li>
          <li>Health Changes</li>
        </ul>
        <p>Additionally, life insurance products change and in recent years have become more modernized. New products in the marketplace may enable you to take advantage of more benefits and/or provide a more economic solution.</p>
      </Container>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/PolicyReview/About/About.js